import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import css from './styles.css'


const PatientRow = ({ id, isTops, first_name, last_name, reminders_email, reminders_phone, formatPhoneNumber }) => {
  const listData = [
    <span key='first_name' className={css.name_first}> {first_name} </span>,
    <span key='last_name' className={css.name_last}>{last_name}</span>,
    <span key='reminders_email' className={css.email}>{reminders_email}</span>,
    <span key='reminders_phone' className={css.phone}>{formatPhoneNumber(reminders_phone)}</span>,
  ]
  return (
    isTops ? (
      <div className={css.rowLink}>
        {listData}
      </div>
    ) : (
        <Link className={css.rowLink} to={`/patients/${id}`}>
          {listData}
        </Link>
      )
  )
}

PatientRow.propTypes = {
  reminders_email: PropTypes.string,
  first_name: PropTypes.string,
  formatPhoneNumber: PropTypes.func.isRequired,
  isTops: PropTypes.bool.isRequired,
  last_name: PropTypes.string,
  reminders_phone: PropTypes.string,
}

export default PatientRow



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/Row.js